/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".copy[_ngcontent-%COMP%]{min-width:480px;display:-webkit-box;display:flex}.copy__input[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1}"];
export { styles as styles };
